import React from 'react'
import { Card, Col, Row, Typography } from 'antd'
import { observer } from 'mobx-react-lite'
import { isMobile } from 'react-device-detect'
const { Text } = Typography
/**
 * @component DashboardCard
 * @description
 * A reusable dashboard UI component for displaying a summary metric card.
 * Typically used on overview or admin dashboards to show KPIs like:
 * - Total users
 * - Pending tasks
 * - Completed items
 * - Earnings, etc.

 * @props
 * @param {string} title - The title or label for the card (e.g., "Total Users").
 * @param {number|string} count - The numerical value to display prominently.
 * @param {React.ReactNode} icon - Optional icon or graphic element shown on the right side.

 * @features
 * - Styled with Ant Design `<Card>` and `<Typography.Text>`.
 * - Displays count in bold large font.
 * - Includes right-aligned icon for visual emphasis.
 * - Uses `mobx-react-lite`'s `observer` to update on observable prop changes.
 * - `hoverable` visual effect is enabled by default.

 * @example
 * <DashboardCard
 *   title="New Signups"
 *   count={42}
 *   icon={<UserAddOutlined style={{ fontSize: 24 }} />}
 * />
 *
 * @returns {React.ReactElement} A styled dashboard summary card.
 */
const DashboardCard = observer(({ title, count, icon, ...props }) => {
	return (
		<Card
			{...props}
			style={{ minWidth: isMobile ? 'unset' : 220 }}
			className="card-hover"
			hoverable
		>
			<Text type="secondary">{title}</Text>
			<Row gutter={16} justify="space-between" align="middle">
				<Col>
					<div
						style={{
							fontSize: 24,
							fontWeight: 'bold',
							marginTop: 4
						}}
					>
						{count}
					</div>
				</Col>
				<Col>{icon}</Col>
			</Row>
		</Card>
	)
})

export default DashboardCard
